<div class="toolbar-spacer"></div>
<div ngbDropdown class="dropdown pb-4 sidebar-dropdown" placement="top-start">
  @if (loginDisplay && credentials) {
  <a class="d-flex align-items-center text-white text-decoration-none dropdown-toggle user-img" id="dropdownUser1" [title]="userName"
    data-bs-toggle="dropdown" aria-expanded="false">
    <img src="../../../../assets/img/person.png" alt="hugenerd" width="30" height="30" class="rounded-circle">

    @if(!collapsedSidebar) {
    <div class="user-info">
      <span class="d-block name-email" title="{{userName}}">{{ userName }}</span>
      <span class="d-block name-email" title="{{userEmail}}">{{ userEmail }}</span>
    </div>
    }
  </a>
  <ul class="dropdown-menu" aria-labelledby="dropdownUser1">
    <li>
      <a class="dropdown-item" [routerLink]="['admin']" (click)="collapseSidebar()"><i class="bi bi-person-circle"
          title="{{'label.profile' | translate}}"></i> <span class="ps-2 display-none">{{'label.profile' |
          translate}}</span>
      </a>
    </li>
    <li>
      <hr class="dropdown-divider">
    </li>
    @if(impersonateService.impersonatedUser) {
    <li>
      <a class="dropdown-item" (click)="exitImpersonateMode()">
        <i class="bi bi-escape" title="{{'label.exit_impersonate_mode' | translate}}"></i>
        <span class="ps-2 display-none">{{ 'label.exit_impersonate_mode' | translate}}</span>
      </a>
    </li>
    } @else {
    <li>
      <a class="dropdown-item" (click)="logout(true)">
        <i class="bi bi-person-x" title="{{'label.sign_out' | translate}}"></i>
        <span class="ps-2 display-none">{{ 'label.sign_out' | translate}}</span>
      </a>
    </li>
    }
  </ul>
  } @else {
  <a class="pb-3" (click)="loginPopup()">{{ 'label.sign_in' | translate }}</a>
  }
</div>
